
import './App.css';
import Contacts from './components/contacts';

function App() {
  return (
    <div className="App">
      
      <Contacts/>
    </div>
  );
}

export default App;
